import { URLS } from '@constants'
import { POSTCopyDTOParams, POSTCreateOrUpdateDTOParams, TimeLineDTOType } from '@types'

import { fetchEnrichedTimelineConfig } from './helpers/fetchEnrichedTimelineConfig'
import { commonAPI } from './common.api'

export const timelineApi = commonAPI.injectEndpoints({
  endpoints: build => ({
    fetchAllTimeLines: build.query<TimeLineDTOType[], void>({
      query: () => ({
        url: URLS.FRONT_CFG + `/timetable`,
        method: 'GET',
      }),
    }),
    fetchTimeLineConfigById: build.query<TimeLineDTOType, number | string>({
      query: id => ({
        url: URLS.FRONT_CFG + `/timetable/id/${id}`,
        method: 'GET',
      }),
    }),
    fetchEnrichedTimeLineConfigById: build.query<TimeLineDTOType, number | string>({
      queryFn: fetchEnrichedTimelineConfig,
    }),
    copyTimeLine: build.mutation<TimeLineDTOType, POSTCopyDTOParams>({
      query: body => ({
        url: URLS.FRONT_CFG + `/timetable/copy`,
        body,
        method: 'POST',
      }),
    }),
    createOrUpdateTimeLine: build.mutation<TimeLineDTOType, POSTCreateOrUpdateDTOParams>({
      query: body => ({
        url: URLS.FRONT_CFG + `/timetable`,
        body,
        method: 'POST',
      }),
    }),
    deleteTimeLine: build.mutation<void, number | string>({
      query: id => ({
        url: URLS.FRONT_CFG + `/timetable/id/${id}`,
        method: 'DELETE',
      }),
    }),
  }),
})

export const {
  useFetchAllTimeLinesQuery,
  useLazyFetchTimeLineConfigByIdQuery,
  useLazyFetchEnrichedTimeLineConfigByIdQuery,
  useCopyTimeLineMutation,
  useCreateOrUpdateTimeLineMutation,
  useDeleteTimeLineMutation,
} = timelineApi
